"use client";

import React from "react";
import styled from "styled-components";
import { AppTextStyles } from "../styles/textStyles";
import BackButton from "./BackButton";

const AppBarContainer = styled.nav<{ $marginBottom?: string; $transparent?: boolean; $height?: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: ${({ $height }) => $height || "60px"};
  padding: 0 16px;
  background-color: ${({ $transparent }) => $transparent ? "transparent" : "#fff"};
  z-index: 1000;
`;

const CenterContainer = styled.div`
  position: absolute;
  left: 64px; /* 좌측 여백 (백버튼/로고 영역) */
  right: 100px; /* 우측 여백 (언어선택/알림 영역 - 아이콘 2개 고려) */
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  
  /* 자식 요소는 클릭 가능하도록 */
  > * {
    pointer-events: auto;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const SideContainer = styled.div`
  display: flex;
`;

const AppbarTitle = styled.h1`
  ${AppTextStyles.title3}
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
`;

interface AppbarProps {
  left?: React.ReactNode; // 좌측 요소 / Left element
  center?: React.ReactNode; // 중앙 요소 / Center element
  right?: React.ReactNode; // 우측 요소 / Right element
  showBackButton?: boolean; // 백버튼 표시 여부 / Show back button
  onBack?: () => void; // 백버튼 클릭 콜백 / Back button click callback
  $marginBottom?: string; // margin-bottom 속성 / Margin bottom property
  $transparent?: boolean; // 투명 배경 여부 / Transparent background
  $height?: string; // 높이 속성 / Height property
  className?: string;
}

export default function Appbar({
  left,
  center,
  right,
  showBackButton = false,
  onBack,
  $marginBottom,
  $transparent,
  $height,
  className,
}: AppbarProps) {
  // left prop이 있으면 그것을 우선, 없고 showBackButton이 true면 BackButton 표시
  const leftContent = left !== undefined ? left : (showBackButton && onBack ? <BackButton onClick={onBack} /> : null);

  // center가 이미 React element(h1 포함)인지 체크하여 중복 h1 방지
  const centerContent = React.isValidElement(center) ? 
    center : 
    center ? <AppbarTitle>{center}</AppbarTitle> : null;

  return (
    <AppBarContainer className={className} $marginBottom={$marginBottom} $transparent={$transparent} $height={$height}>
      <SideContainer>{leftContent}</SideContainer>
      <CenterContainer>
        {centerContent}
      </CenterContainer>
      <SideContainer>{right}</SideContainer>
    </AppBarContainer>
  );
}
